import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './index.less';

const cx = classNames.bind(styles);

const defaultProps = {
  addonBefore: null,
  addonAfter: null,
};
const propTypes = {
  addonBefore: PropTypes.element,
  addonAfter: PropTypes.element,
  children: PropTypes.any.isRequired,
};

const ListItem = ({
  addonBefore,
  addonAfter,
  children,
}) => (
    <div className={cx('listItem')}>
      {addonBefore}
      {children}
      {addonAfter}
    </div>
  );

ListItem.defaultProps = defaultProps;
ListItem.propTypes = propTypes;
export default ListItem;



// WEBPACK FOOTER //
// ./src/components/ui/ListItem/Item.jsx